import React, { Component } from 'react';
class ChangePassword extends Component {
  constructor() {
    super();
    this.state = {
        submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.change_emp_password.bind(this)}>Update</button>,
    };
  }

componentDidMount(){
}

change_emp_password(){

}

  render() {
    return (
      <div className="col-md-12 mt-4 mb-4">
      <h3 className="wow fadeInUp" data-wow-delay="0.1s">Change Password</h3>
          <div className="wow fadeInUp" data-wow-delay="0.5s">
              <form action="" method="post">
                  <div className="row g-3">

                      <div className="col-md-4">
                          <div className="form-floating">
                              <input type="text" className="form-control" id="user_full_name" placeholder="Current Password"/>
                              <label for="name">Current Password</label>
                          </div>
                      </div>

                      <div className="col-md-4">
                          <div className="form-floating">
                              <input type="text" className="form-control" id="user_full_name" placeholder="New Password"/>
                              <label for="name">New Password</label>
                          </div>
                      </div>

                      <div className="col-md-4">
                          <div className="form-floating">
                              <input type="text" className="form-control" id="user_full_name" placeholder="Confirm New Password"/>
                              <label for="name">Confirm New Password</label>
                          </div>
                      </div>


                      <div className="col-md-12">
                      <p>Your password must be at least 10 characters long and include a mix of uppercase and lowercase letters, numbers, and symbols.</p>
                      <div className="col-md-8">
                        <p id="error_msg"></p>
                      </div>
                        <div className="col-md-4 p-0 float_r">
                            {this.state.submit_button}
                        </div>
                      </div>

                  </div>
            </form>
          </div>
      </div>
    );
  }
}

export default ChangePassword;
